angular.module('salesPath2')
.service('suggestedSumInsuredHelper', ['sp2CommonHelper', 'dataContainerHelper', 'MapperUtils', 'CONSTANTS', 'mainDataContainer', '$sce', 
  function(sp2CommonHelper, dataContainerHelper, MapperUtils, CONSTANTS, mainDataContainer, $sce) {
    var SuggestedSumInsuredHelper = function() {
      var self = this;

      //ustawienia modali
      this.modals = {};

      this.modals.suggestedSumInsuredModal = {
        settings: {
          treatLabelAsI18nCode: true,
          title: 'sp2.matrix.sumInsured',
          size: 'sm',
          okBtnName: 'sp2.modal.close',
          cancelBtnName: false
        }
      };

      this.tplData = {
        content: ''
      };

      /**
       * wyciagnij wszystkie message o kodzie P200339 lub P200340, przygotuj zbiorczy content do modala, pokaz modala
       */
      this.checkMessages = function(messages) {    
        var filteredMessages = messages.filter(function(message) {
          return (message.code === 'P200339' || message.code === 'P200340');
        });

        if (filteredMessages.length > 0) {
          var content = filteredMessages.map(function(msg) {
            return msg.text;
          }).join('<br/><br/>');
          self.tplData.content = $sce.trustAsHtml(content);
          return true;
        }

        return false;
      };

      /**
       * dla kazdego ryzyka z ustawionym SuggestedSumInsured wyciagnij kod ryzyka i id nieruchomosci
       * zaktualizuj sumInsured na nim i ustaw SumInsuredWasSetOnRenewal na true
       */
      this.setSumInsured = function() {
        angular.forEach(dataContainerHelper.getRisks(), function(risk) {
          if (risk.product.dynamicValues.suggestedSumInsured) {
            var def = MapperUtils.findRiskDefByIdpm(risk.product.compId);
            var clientId = dataContainerHelper.getClientId(CONSTANTS.PRODUCT_TYPE_LOCALIZATION, risk.insuredObjectsRef[0].ref);
            dataContainerHelper.setSu(CONSTANTS.PRODUCT_TYPE_LOCALIZATION, clientId, def.productCode, risk.product.dynamicValues.suggestedSumInsured, 'estate');
            mainDataContainer.localizations[clientId].dynamicValues.sumInsuredWasSetOnRenewal = true;
          }
        });
      };

      /**
       * Wyświetlenie modala
       */
      this.showModal = function() {
        sp2CommonHelper.showModal('suggestedSumInsuredModal');
      };
    };

    return new SuggestedSumInsuredHelper();
  }
]);